import ProgressStatusParameters from 'dashboard/templates/views/Patient/Progress/ProgressStatusParameters';

export default {
  path: 'parameters',
  name: 'PatientRecordProgressStatusParameters',
  props: true,
  component: ProgressStatusParameters,
  meta: {
    // title: 'Patient Record - Progress - Status - Parameters',
    // title: t => `${t('patient.patientRecord')} - ${t('journeyProgress.progress')} - ${t('journeyBehaviourChangeGoals.status')} - ${t('journeyProgress.parameters')}`,
    // title: 'Journey - Status',
    title: t => `${t('buttons.journey', 'app_mobile')} - ${t('journeyBehaviourChangeGoals.status')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true
  }
};
